import React, { useContext } from "react";
import { useEffect } from "react";
import Iframe from "../../components/iframe/Iframe.component";
import RealTimeSyncModal from "../../components/RealTimeSyncModal/RealTimeSyncModal";
import { ConfigContext } from "../../context/config";
import useIdentity from "../../utils/identity";
import { useSelector } from "react-redux";
import axios from "axios";
import { useState } from "react";
import GetDesoProfile from "../../Hooks/GetDesoProfile";
import { useDispatch } from "react-redux";
import {
  handleRealTimeModal,
  handleRealTimeSync,
  setShowIFrame,
} from "../../reducers/auth/action";
import AllTweetComponents from "../../components/RealTimeSyncTweet/AllTweet.component";
import Spinner from "../../components/spinner/Spinner.component";
import { Helmet } from "react-helmet";
import GoBack from "../../components/goBack/GoBack";
import { Toast } from "../../components/Toast/Toast.components";
import IncludeTweetComponent from "../../components/RealTimeSyncTweet/IncludeTweet.component";
import {
  changeSubscriptionApi,
  createSubscriptionApi,
  currentSubscriptionApi,
  getCurrentSubWordpressApi,
  getDerivedKeyStatusApi,
  unsubscribeSubscriptionApi,
} from "../../Network/network";
import { Fade } from "react-reveal";
import StepComponents, {
  checkArray,
  checkingStep2,
} from "../../components/Dashboard/Step.components";
import Swal from "sweetalert2";
import { useParams } from "react-router-dom";
import { logEvent } from "firebase/analytics";
import { analytics } from "../../utils/firebase";
import { gaEvents, pushGaEvent } from "../../utils/ga_events";

function isIOSDevice() {
  return !!navigator.platform && /iPad|iPhone|iPod/.test(navigator.platform);
}

export let deriveUrl =
  "https://identity.deso.org/derive?expirationDays=365&transactionSpendingLimitResponse=%7B%22GlobalDESOLimit%22:1000000000,%22TransactionCountLimitMap%22:%7B%22SUBMIT_POST%22:1000000,%22UPDATE_PROFILE%22:1000000,%22AUTHORIZE_DERIVED_KEY%22:2%7D%7D";

export const RealTimeSync = () => {
  const { id } = useParams();
  const pn = window.location.pathname;
  const result = checkArray(checkingStep2, pn);
  if (result) {
  } else {
    window.location.href = "/";
  }
  const [currentLoading, setCurrentLoading] = useState(true);
  const [choices, setChoices] = useState({});
  const [allTweet, setAllTweet] = useState(true);
  const [includeHash, setIncludeHash] = useState(false);
  const [excludeHash, setExcludeHash] = useState(false);
  const [allTweetRetweet, setAllTweetRetweet] = useState(true);
  const [allTweetQRetweet, setAllTweetQRetweet] = useState(true);
  const [includeHashRetweet, setIncludeHashRetweet] = useState(false);
  const [includeHashQRet, setIncludeHashQRet] = useState(false);
  const [excludeQRet, setExcludeQRet] = useState(false);
  const [excludeRet, setExcludeRet] = useState(false);
  const [includeHashes, setIncludeHashes] = useState(["#web3", "#deso"]);
  const [includeHashtag, setIncludeHashtag] = useState("");
  const [excludeHashtag, setExcludeHashtag] = useState("");
  const [excludeHashes, setExcludeHashes] = useState(["#web3", "#deso"]);
  const [deleteShow, setDeleteShow] = useState(false);
  const [current, setCurrent] = useState({});
  const [changes, setChanges] = useState(false);
  const [finalHashes, setFinalHashes] = useState([]);
  const [deriveKeyState, setDeriveKeyState] = useState();
  const [newUser, setNewUser] = useState(false);
  const [deriveApiRes, setDeriveApiRes] = useState();

  const handleSubmit = (e, x, y, f, id) => {
    e.preventDefault();
    let uniqueChars = [...new Set([...x, y])];
    f(uniqueChars);
    const input = document.getElementById(id);
    input.value = "";
  };
  const handleDelete = (value, H, f) => {
    const result = H.filter((hastag) => hastag !== value);
    f(result);
  };

  const { deso, twitter, realTimeModal, approve, wordpress } = useSelector(
    (state) => state.auth
  );

  const { username } = GetDesoProfile();
  // check if the user is logged in
  useEffect(() => {
    if (localStorage.getItem("credential")) {
    } else window.location.href = "/home";
    if (id === "wordpress") {
      if (localStorage.getItem("wordpress_info")) {
      } else {
        window.location.href = "/home";
      }
    } else if (id === "twitter") {
      if (localStorage.getItem("twitter_username")) {
      } else {
        window.location.href = "/home";
      }
    }
  }, [twitter, deso, wordpress]);

  const { identityWindow, setCreateSubscriptionState } =
    useContext(ConfigContext);
  const {
    handleMessage,
    unsubscribeIdentity,
    withoutDeriveKeySubscibeIdentity,
    changeSignIdentity,
  } = useIdentity();

  useEffect(() => {
    window.addEventListener("message", (event) =>
      handleMessage(event, identityWindow)
    );
  }, [identityWindow]);

  useEffect(() => {
    if (!excludeHash) {
      setChoices({});
      setExcludeQRet(false);
      setExcludeRet(false);
    }
  }, [excludeHash]);

  useEffect(() => {
    if (!allTweet) {
      setChoices({});
      setAllTweetQRetweet(false);
      setAllTweetRetweet(false);
    }
  }, [allTweet]);

  useEffect(() => {
    if (!includeHash) {
      setChoices({});
      setIncludeHashRetweet(false);
      setIncludeHashQRet(false);
    }
  }, [includeHash]);

  useEffect(() => {
    if (allTweetQRetweet || allTweetRetweet) {
      setAllTweet(true);
      setExcludeHash(false);
      setIncludeHash(false);
      setExcludeRet(false);
      setExcludeQRet(false);
      setIncludeHashRetweet(false);
      setIncludeHashQRet(false);
      setChoices({
        allTweet: true,
        allTweetQRetweet: allTweetQRetweet,
        allTweetRetweet: allTweetRetweet,
      });
    }
  }, [allTweetQRetweet, allTweetRetweet]);

  useEffect(() => {
    if (includeHashRetweet || includeHashQRet || includeHash) {
      setIncludeHash(true);
      setAllTweet(false);
      setExcludeHash(false);
      setExcludeRet(false);
      setExcludeQRet(false);
      setAllTweetQRetweet(false);
      setAllTweetRetweet(false);
      setChoices({
        includeHash: true,
        includeHashRetweet: includeHashRetweet,
        includeHashQRet: includeHashQRet,
      });
    }
  }, [includeHashRetweet, includeHashQRet, includeHash]);

  useEffect(() => {
    if (excludeQRet || excludeRet || excludeHash) {
      setExcludeHash(true);
      setAllTweet(false);
      setIncludeHash(false);
      setAllTweetQRetweet(false);
      setAllTweetRetweet(false);
      setIncludeHashRetweet(false);
      setIncludeHashQRet(false);
      setChoices({
        excludeHash: true,
        excludeQRet: excludeQRet,
        excludeRet: excludeRet,
      });
    }
  }, [excludeQRet, excludeRet, excludeHash]);

  const handleAllTweet = () => {
    pushGaEvent(`SEND_ALL_${id === "twitter" ? "TWEETS" : "BLOGS"}_CLICKED`);
    setAllTweet(!allTweet);
    setExcludeHash(false);
    setIncludeHash(false);
    setExcludeRet(false);
    setExcludeQRet(false);
    setIncludeHashRetweet(false);
    setIncludeHashRetweet(false);
  };

  const handleInTweet = () => {
    pushGaEvent(
      `SEND_INCLUDE_${id === "twitter" ? "TWEETS" : "BLOGS"}_CLICKED`
    );
    setIncludeHash(!includeHash);
    setAllTweet(false);
    setExcludeHash(false);
    setAllTweetQRetweet(false);
    setAllTweetRetweet(false);
    setExcludeRet(false);
    setExcludeQRet(false);
  };

  const handleExTweet = () => {
    pushGaEvent(
      `SEND_EXCLUDE_${id === "twitter" ? "TWEETS" : "BLOGS"}_CLICKED`
    );
    setExcludeHash(!excludeHash);
    setAllTweet(false);
    setIncludeHash(false);
    setAllTweetQRetweet(false);
    setAllTweetRetweet(false);
    setIncludeHashRetweet(false);
    setIncludeHashRetweet(false);
  };

  const arrayToString = (array) => {
    return array.join(",");
  };
  const stringToArray = (string) => {
    return string.split(",");
  };

  const h = 1000;
  const w = 800;
  const y = window.outerHeight / 2 + window.screenY - h / 2;
  const x = window.outerWidth / 2 + window.screenX - w / 2;
  const public_key = deso?.user?.publicKeyAdded;
  let uid;
  if (id === "twitter") {
    uid = twitter?.user?.providerData[0]?.uid;
  }
  const dispatch = useDispatch();

  const handleDeprive = async (value) => {
    if (value == "true") {
      pushGaEvent(id.toUpperCase() + "_SUBSCRIBE_BUTTON_CLICKED_OLD_USER");
    } else {
      pushGaEvent(id.toUpperCase() + "_SUBSCRIBE_BUTTON_CLICKED_NEW_USER");
    }
    const twiiterUserName = localStorage.getItem("twitter_username");

    let fomData = new FormData();
    fomData.append("public_key", public_key);

    if (id === "twitter") fomData.append("twitter_user_id", uid);
    else if (id === "wordpress") {
      fomData.append("wordpress_user_id", wordpress?.user?.user_id);
      fomData.append("blog_id", wordpress?.user?.blog_id);
    }
    if (value == "true") {
      fomData.append("username_deso", username);
      if (id == "twitter") fomData.append("twitter_username", twiiterUserName);
      else if (id == "wordpress") {
        fomData.append("wordpress_username", wordpress?.user?.display_name);
      }
    }
    if (includeHash) {
      fomData.append("subscription_type", "include_hashtags");
      fomData.append("hashtags", arrayToString(includeHashes));
      if (id === "twitter") {
        fomData.append("include_retweets", includeHashRetweet);
        fomData.append("include_quote_tweets", includeHashQRet);
      }
      if (includeHashes.length == 0) {
        Toast.fire({
          icon: "warning",
          title: "Please add hashtags",
        });
        return;
      }
    } else if (allTweet) {
      fomData.append("subscription_type", "all_tweets");
      fomData.append("hashtags", " ");
      if (id === "twitter") {
        fomData.append("include_retweets", allTweetRetweet);
        fomData.append("include_quote_tweets", allTweetQRetweet);
      }
    } else if (excludeHash) {
      fomData.append("subscription_type", "exclude_hashtags");
      fomData.append("hashtags", arrayToString(excludeHashes));
      if (id === "twitter") {
        fomData.append("include_retweets", excludeRet);
        fomData.append("include_quote_tweets", excludeQRet);
      }
      if (excludeHashes.length == 0) {
        Toast.fire({
          icon: "warning",
          title: "Please add hashtags",
        });
        return;
      }
    }
    dispatch(handleRealTimeSync(fomData));
    if (value == "true") {
      if (allTweet || includeHash || excludeHash) {
        if (
          deriveApiRes?.status === "success" &&
          deriveApiRes?.is_expired === false
        ) {
          setCreateSubscriptionState(true);
          window.addEventListener("message", (event) =>
            handleMessage(event, identityWindow)
          );
          withoutDeriveKeySubscibeIdentity();
        } else {
          sessionStorage.setItem("sync_past_tweet", "real_time_sync");
          identityWindow.current = window.open(deriveUrl, null);
        }
      } else {
        Toast.fire({
          icon: "warning",
          title: "Please add one service",
        });
      }
    } else {
      setDeriveKeyState(true);
      window.addEventListener("message", (event) =>
        handleMessage(event, identityWindow)
      );
      changeSignIdentity();
    }
  };

  let bodyData = new FormData();
  bodyData.append("public_key", public_key);
  if (id === "twitter") {
    bodyData.append("twitter_user_id", uid);
  } else if (id === "wordpress") {
    bodyData.append("wordpress_user_id", wordpress?.user?.user_id);
    bodyData.append("blog_id", wordpress?.user?.blog_id);
  }

  useEffect(() => {
    if (public_key) {
      fetchData();
    }
  }, [uid, public_key, wordpress]);

  const fetchData = async () => {
    if (isIOSDevice()) {
      sessionStorage.setItem("storage_granted", "dont show");
      dispatch(setShowIFrame(true));
    }

    let deriveBodyData = {
      public_key: public_key,
    };
    if (pn == "/wordpress/real_time_sync") {
      deriveBodyData["permission_type"] = "update_profile";
    }
    const deriveApi = await getDerivedKeyStatusApi(deriveBodyData);
    setDeriveApiRes(deriveApi);
    if (id === "twitter") {
      const data = await currentSubscriptionApi(bodyData);
      if (data?.status == "error") {
        if (data?.error == "Subscription does not exist\n") {
          setNewUser(true);
        }
      } else if (data?.status == "success") {
        if (data?.subscription_type === "include_hashtags") {
          const result = stringToArray(data?.hashtags);
          setFinalHashes(result);
          setIncludeHashes(result);
          setIncludeHash(true);
          setIncludeHashRetweet(data?.include_retweets);
          setIncludeHashQRet(data?.include_quote_tweets);
          const objectData = {
            includeHash: true,
            includeHashRetweet: data?.include_retweets,
            includeHashQRet: data?.include_quote_tweets,
          };
          setCurrent({ objectData, buttonShow: true });
        } else if (data?.subscription_type === "all_tweets") {
          setAllTweet(true);
          setAllTweetRetweet(data?.include_retweets);
          setAllTweetQRetweet(data?.include_quote_tweets);

          const objectData = {
            allTweet: true,
            allTweetRetweet: data?.include_retweets,
            allTweetQRetweet: data?.include_quote_tweets,
          };
          setCurrent({ objectData, buttonShow: true });
        } else if (data?.subscription_type === "exclude_hashtags") {
          const result = stringToArray(data?.hashtags);
          setFinalHashes(result);
          setExcludeHashes(result);
          setExcludeHash(true);
          setExcludeRet(data?.include_retweets);
          setExcludeQRet(data?.include_quote_tweets);
          const objectData = {
            excludeHash: true,
            excludeRet: data?.include_retweets,
            excludeQRet: data?.include_quote_tweets,
          };
          setCurrent({ objectData, buttonShow: true });
        }
      }
    } else if (id === "wordpress") {
      const data = await getCurrentSubWordpressApi(bodyData);
      if (data?.status == "error") {
        if (data?.error == "Subscription does not exist\n") {
          setNewUser(true);
        }
      } else if (data?.status == "success") {
        if (data?.subscription_type === "include_hashtags") {
          const result = stringToArray(data?.hashtags);
          setFinalHashes(result);
          setIncludeHashes(result);
          setIncludeHash(true);
          const objectData = {
            includeHash: true,
          };
          setCurrent({ objectData, buttonShow: true });
        } else if (data?.subscription_type === "all_tweets") {
          setAllTweet(true);
          const objectData = {
            allTweet: true,
          };
          setCurrent({ objectData, buttonShow: true });
        } else if (data?.subscription_type === "exclude_hashtags") {
          const result = stringToArray(data?.hashtags);
          setFinalHashes(result);
          setExcludeHashes(result);
          setExcludeHash(true);
          const objectData = {
            excludeHash: true,
          };
          setCurrent({ objectData, buttonShow: true });
        }
      }
    }

    setCurrentLoading(false);
  };

  const handleDeleteModalShow = () => {
    pushGaEvent(gaEvents[`${id.toUpperCase()}_UNSUBSCRIBE_BUTTON_CLICKED`]);
    setDeleteShow(true);
  };

  useEffect(() => {
    if (current.objectData && choices) {
      const check =
        JSON.stringify(current.objectData) == JSON.stringify(choices);
      if (!check) {
        setChanges(true);
      } else {
        setChanges(false);
      }
    }
  }, [current.objectData, allTweet, includeHash, excludeHash, choices]);

  useEffect(() => {
    if (current) {
      if (includeHash && finalHashes) {
        if (includeHashes.length != finalHashes.length) {
          setChanges(true);
        }
      }
    }
  }, [includeHashes, finalHashes, current]);

  const handleUnSubscribe = async () => {
    pushGaEvent(
      gaEvents[`${id.toUpperCase()}_UNSUBSCRIBE_CONFIRM_BUTTON_CLICKED`]
    );
    if (public_key) {
      window.addEventListener("message", (event) =>
        handleMessage(event, identityWindow)
      );
      unsubscribeIdentity();
    }
  };

  useEffect(() => {
    if (approve) {
      window.open(
        "https://identity.deso.org/approve",
        null,
        `toolbar=no, width=${w}, height=${h}, top=${y}, left=${x}`
      );
    }
  }, [approve]);

  return (
    <>
      <Helmet>
        <title>Setu - Real Time Sync</title>
        <meta
          name="description"
          content="Sync you content to Deso using Setu in real time"
        />
      </Helmet>

      {currentLoading ? (
        <div className="h-[80vh] items-center flex justify-center">
          <Spinner />
        </div>
      ) : (
        <section className="container mx-auto py-4 px-4 sm:px-4 md:px-12 mb-16">
          {/* <StepComponents /> */}
          {(realTimeModal || deleteShow) && (
            <RealTimeSyncModal
              deleteShow={deleteShow}
              setDeleteShow={setDeleteShow}
              UnSubscribe={handleUnSubscribe}
              real_time_show={true}
            />
          )}
          <Iframe />
          <StepComponents />
          {/* comment */}
          <Fade cascade duration={1000}>
            <div className="text-center">
              <h1 className="text-[30px] md:text-[36px] font-bold">
                Auto-sync from {id === "twitter" ? "Twitter" : "Wordpress"} to
                DeSo
              </h1>
              <p
                className={`${
                  current.buttonShow === true ? "text-blue" : "text-[#161616]"
                } mt-[8px] text-[14px] md:text-[16px] `}
              >
                {current.buttonShow === true ? (
                  <>You are currently subscribed with the selected option</>
                ) : (
                  <> Choose how you want your tweets to be synced</>
                )}
              </p>
            </div>
            <div className="grid sm:grid-cols-1 md:grid-cols-1 lg:grid-cols-2 xl:grid-cols-3 gap-6 mt-[32px] justify-center">
              <AllTweetComponents
                title={`Send All ${id === "twitter" ? "Tweets" : " Blogs"}`}
                allTweet={allTweet}
                handleAllTweet={handleAllTweet}
                setAllTweetQRetweet={setAllTweetQRetweet}
                setAllTweetRetweet={setAllTweetRetweet}
                allTweetRetweet={allTweetRetweet}
                allTweetQRetweet={allTweetQRetweet}
                id={id}
              />

              <IncludeTweetComponent
                title={`Send ${
                  id == "twitter" ? "Tweets" : "Blogs"
                } including ${id == "twitter" ? "hashtags" : "tags"}`}
                option={id}
                description={"include"}
                includeHash={includeHash}
                handleInTweet={handleInTweet}
                handleSubmit={handleSubmit}
                setIncludeHashtag={setIncludeHashtag}
                includeHashes={includeHashes}
                handleDelete={handleDelete}
                setIncludeHashes={setIncludeHashes}
                setIncludeHashRetweet={setIncludeHashRetweet}
                includeHashRetweet={includeHashRetweet}
                setIncludeHashQRet={setIncludeHashQRet}
                includeHashQRet={includeHashQRet}
                includeHashtag={includeHashtag}
                id="includeHashtag"
              />
              <IncludeTweetComponent
                title={`Send ${
                  id == "twitter" ? "Tweets" : "Blogs"
                } excluding ${id == "twitter" ? "hashtags" : "tags"}`}
                option={id}
                description={"exclude"}
                includeHash={excludeHash}
                handleInTweet={handleExTweet}
                handleSubmit={handleSubmit}
                setIncludeHashtag={setExcludeHashtag}
                includeHashes={excludeHashes}
                handleDelete={handleDelete}
                setIncludeHashes={setExcludeHashes}
                setIncludeHashRetweet={setExcludeRet}
                includeHashRetweet={excludeRet}
                setIncludeHashQRet={setExcludeQRet}
                includeHashQRet={excludeQRet}
                includeHashtag={excludeHashtag}
                id="excludeHashtag"
              />
            </div>

            <div className="text-center md:mt-8 fixed sm:fixed lg:static bottom-0 sm:bottom-0 bg-[#FFFFFF] left-0 md:left-0 w-[100%] shadow-class">
              {current.buttonShow == true && (
                <p className="text-[14px] sm:text-[14px] md:text-[16px] text-black mt-[8px] md:pb-[16px]">
                  To change settings, select your preferred option{" "}
                  <span className="hidden sm:hidden md:inline">
                    <br />
                  </span>{" "}
                  and save it.
                </p>
              )}

              <div
                className={`${
                  current?.objectData
                    ? "h-[110px] sm:h-[110px] md:h-[80px]"
                    : "h-[110px] sm:h-[110px]"
                } flex justify-center items-center`}
              >
                <div className="button_hover">
                  <button
                    onClick={
                      current?.objectData && changes
                        ? () => handleDeprive("false")
                        : () => handleDeprive("true")
                    }
                    disabled={current?.objectData ? !changes : false}
                    className=" hero_button lg:mt-6 h-[56px] w-[183px] rounded-[8px] justify-center mx-2"
                  >
                    {current.buttonShow == true
                      ? "Save Changes"
                      : " Subscribe for free"}
                  </button>
                </div>
                {current.buttonShow === true && (
                  <button
                    onClick={handleDeleteModalShow}
                    className=" p-5 h-[56px] lg:mt-6 justify-center bg-white text-black w-[158px]  mx-2"
                  >
                    Unsubscribe
                  </button>
                )}
              </div>
            </div>
          </Fade>
        </section>
      )}
    </>
  );
};
